import { Injectable } from '@angular/core';
import { BaseService } from './base-service.service';
import { HttpClient } from '@angular/common/http';
import { AutomationLogs, Automations, LoginLogs, SignInListRequestParams } from '@intellio/shared/models';
import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class SignInLogService extends BaseService {
  readonly PAGE_SIZE = 25;
  constructor(
    protected client: HttpClient,
    protected configService: AppConfigService,
    protected authService: AuthService
  ) {
    super(client, configService, authService);
  }

  getSignInLogs(params: SignInListRequestParams) {
    const url = '/api/logs/logins';
    const config = { params: params, ignoreLoadingBar: true };

    return this.get<LoginLogs>(url, config);
  }
}